// v8-ad 头部倒计时
if ($("#v8-ad-countdown").length > 0) {
  $.ajax({
    url: 'https://backend.turboant.com/index/api/getCountdownTime',
    type: 'get',
    data: {
      page: 'https://turboant.com/pages/v8-electric-scooter-for-heavy-adults'
    },
    dataType: 'json',
    success: (res) => {
      if (res.data.status === 1) {
        let time = res.data.time;
        $(`#v8-ad-countdown`).timeTo({
          timeTo: new Date(time),
          theme: "black",
          displayDays: 2,
          displayCaptions: true,
          fontSize: !isMobile() ? 30 : 18,
          captionSize: !isMobile() ? 14 : 12,
          lang: 'en',
          countdown: true,
          languages: {
            en: {
              days: 'D',
              hours: 'H',
              min: 'M',
              sec: 'S',
            }
            
          }
        });
      }
    }
  });
}

// x7-pro广告页
if ($("#x7-pro-ad-countdown").length > 0) {
  $.ajax({
    url: 'https://backend.turboant.com/index/api/getCountdownTime',
    type: 'get',
    data: {
      page: 'https://turboant.com/pages/electric-scooter-for-commuting'
    },
    dataType: 'json',
    success: (res) => {
      if (res.data.status === 1) {
        let time = res.data.time;
        $(`#x7-pro-ad-countdown`).timeTo({
          timeTo: new Date(time),
          theme: "black",
          displayDays: 2,
          displayCaptions: true,
          fontSize: !isMobile() ? 30 : 18,
          captionSize: !isMobile() ? 14 : 12,
          lang: 'en',
          countdown: true,
          languages: {
            en: {
              days: 'D',
              hours: 'H',
              min: 'M',
              sec: 'S',
            }
            
          }
        });
      }
    }
  });
}


var swiper = new Swiper(".v8-ad-swiper", {
  loop:true,
  navigation: {
    nextEl: ".v8-ad-swiper .swiper-button-next",
    prevEl: ".v8-ad-swiper .swiper-button-prev",
  },
  on: {
    init: function () {
      const video = document.querySelector(".ad-video");
      if (video) {
       video.muted = true;
       video.play();       
      }
    },
    slideChange: function () {
      const video = document.querySelector(".ad-video");
      if (video) {
        if (this.activeIndex === 0) {
          video.play();
        } else {
          video.pause();
        }
      }

    },
  },
});

// Initialize Swiper
swiper.init();


var socialThumbSwiper = new Swiper(".socialMediaSwiperThumb", {
  spaceBetween: 15,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
});

var socialMediaSwiper = new Swiper(".socialMediaSwiper", {
  autoplay: true,
  loop: true,
  thumbs: {
    swiper: socialThumbSwiper,
  },
});



function showImage(event) {
  console.log(2345);
  // 获取原始图像的 src 属性
  const src = event.target.src;

  // 创建遮罩层
  const overlay = document.createElement('div');
  overlay.classList.add('overlay');

  // 创建放大的图像并将其添加到遮罩层
  const img = document.createElement('img');
  img.src = src;
  overlay.appendChild(img);

  // 将遮罩层添加到 body
  document.body.appendChild(overlay);
  overlay.style.display = "block";

  // 当点击遮罩层时，删除遮罩层
  overlay.addEventListener('click', () => {
    document.body.removeChild(overlay);
  });
}

function playVideo(event) {
  // 获取 YouTube 视频的 URL
  const videoUrl = event.target.dataset.videoUrl;

  // 创建遮罩层
  const overlay = document.createElement('div');
  overlay.classList.add('overlay');

  // 设置遮罩层的 display 属性为 block，使其显示
  overlay.style.display = 'block';

  // 创建 iframe 并将其添加到遮罩层
  const iframe = document.createElement('iframe');
  iframe.src = videoUrl;
  iframe.allow = 'autoplay; encrypted-media';
  iframe.allowFullscreen = true;
  iframe.frameBorder = 0;
  overlay.appendChild(iframe);

  // 将遮罩层添加到 body
  document.body.appendChild(overlay);

  // 当点击遮罩层时，删除遮罩层并停止播放视频
  overlay.addEventListener('click', () => {
    iframe.src = '';
    document.body.removeChild(overlay);
  });
}


let playButton = document.querySelector(".play-button img");
let videoContainer = document.querySelector(".video-container");
let videoPlayer = document.querySelector("#videoPlayer");
let videoThumbnail;
let player;


playButton.addEventListener("click", () => {
  playVideoOnImage();
});

function playVideoOnImage() {
  playButton.style.display = "none";

  if (isMobile()) {
    videoThumbnail = document.querySelector(".video-thumbnail.wap-banner");
  } else {
    videoThumbnail = document.querySelector(".video-thumbnail.web-banner");
  }

  // 获取图片的宽度和高度
  let imgWidth = videoThumbnail.offsetWidth;
  let imgHeight = videoThumbnail.offsetHeight;

  videoThumbnail.style.display = "none";
  videoPlayer.style.display = "block";

  // 设置iframe的宽度和高度为图片的宽度和高度
  videoPlayer.style.width = imgWidth + "px";
  videoPlayer.style.height = imgHeight + "px";

  let videoUrl = playButton.getAttribute("data-video-url");
  let videoId = videoUrl.split("embed/")[1];
  let playerUrl = videoUrl + "?autoplay=1&enablejsapi=1";

  // 使用 <iframe> 标签并设置新的 src
  videoPlayer.setAttribute("src", playerUrl);
}


$('.subscribe-input-box .summit-botton').on('click', function (e) {
  let email = $('#email').val();
  console.log(email);
  if (email) {
      $.ajax({
          url: 'https://backend.turboant.com/index/api/dealshopifycustomer',
          type: 'post',
          data: {
              account: 'turboant.myshopify.com',
              email: $('#email').val()
          },
          dataType: 'json',
          success: (res) => {
              const { status, msg } = res;
              if (status === 1) {
                  $('.subscribe-card').append(`<div class='tb-toast'>Subscribe to the success!</div>`);
                  setTimeout(function () {
                      $('.tb-toast').remove();
                  }, 1000)
              } else {
                  $('.subscribe-card').append(`<div class='tb-toast'>${msg}</div>`);
                  setTimeout(function () {
                      $('.tb-toast').remove();
                  }, 1000)
              }
          }
      });
  } else {
      $('.subscribe-card').append(`<div class='tb-toast'>Please enter your email address.</div>`);
      setTimeout(function () {
          $('.tb-toast').remove();
      }, 1000)
  }

});


var gridSwiper = new Swiper(".gridSwiper", {
  loop: true,
  pagination: {
    el: ".gridSwiper .swiper-pagination",
  },
});


var reviewSwiper = new Swiper(".review-swiper", {
  spaceBetween: isMobile() ? 20 : 40,
  centeredSlides: isMobile() ? false : true,
  loop: true,
  slidesPerView: isMobile() ? 1.1 : 1.5,
  pagination: {
    el: ".review-swiper .swiper-pagination",
  }
});

$('.product-add-cart-botton').on('click', function (e) {
  let id = $(this).data('variantid') || $(this).data('id');
  addCartFn(id)
})